import React from "react";
import { isAuthenticated } from "../../../commons/Auth/auth";
import SalarySlipsList from "../../../commons/Employees/SalarySlips/SalarySlips";

const EmployeeSalarySlips = () => {
  const user = isAuthenticated();

  return (
    <>
      <SalarySlipsList employee={user} />
    </>
  );
};

export default EmployeeSalarySlips;
